import { t } from '../lib/strings';

// Privacy + AI-visualization disclaimer, with an inline link to the shop's privacy policy.
// The text has two parts — a privacy notice and a legal/quality notice — that are shown in
// different places:
//   variant 'full'    → both parts (logged-out info modal).
//   variant 'privacy' → only the privacy notice (upload-page consent checkbox).
//   variant 'legal'   → only the "Bei dem generierten Bild …" notice (result page).
// The link URL + label are configurable in the plugin settings (passed via config); an empty
// URL renders the label as plain text (no broken href). `inline` renders a <span> instead of a
// <p> so the privacy variant can sit inside a <label>.
export function Disclaimer({
  url,
  label,
  variant = 'full',
  inline = false,
}: {
  url: string;
  label: string;
  variant?: 'full' | 'privacy' | 'legal';
  inline?: boolean;
}) {
  const text = label || t('disclaimer_link');
  const link = url ? (
    <a className="aiw-link" href={url} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  ) : (
    text
  );

  const privacy = (
    <>
      {t('disclaimer_privacy_pre')}
      {link}
      {t('disclaimer_privacy_post')}
    </>
  );
  const legal = t('disclaimer_legal');

  const content =
    variant === 'privacy' ? privacy : variant === 'legal' ? legal : (
      <>
        {privacy} {legal}
      </>
    );

  const Tag = (inline ? 'span' : 'p') as 'span' | 'p';
  return <Tag className="aiw-muted aiw-small">{content}</Tag>;
}
